// Internal modules
import { getGlobals } from '../../globals';

const { uri } = getGlobals();

export const REDIRECT_URLS_MAP = {
  hermes: `${uri.base}/webapps/hermes`,
  tesla: `${uri.base}/welcome/flow/signup`,
  xoon: `${uri.base}/webapps/xoonboarding`,
};
